export default __webpack_public_path__ + "0d96effa016d65da4576284d9fa943dd.mp4";